import React, { createContext, useContext, useMemo } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getLocale, defaultLocale, supportedLocales } from '../locales';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const { lang } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const currentLang = supportedLocales.includes(lang) ? lang : defaultLocale;
  const t = useMemo(() => getLocale(currentLang), [currentLang]);

  const switchLanguage = (newLang) => {
    if (supportedLocales.includes(newLang) && newLang !== currentLang) {
      const pathParts = location.pathname.split('/').filter(Boolean);

      // Remove current lang prefix if exists
      if (supportedLocales.includes(pathParts[0])) {
        pathParts.shift();
      }

      // Build new path with new lang
      const newPath = `/${newLang}/${pathParts.join('/')}`;
      navigate(newPath);
    }
  };

  const getLocalizedPath = (path) => {
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return `/${currentLang}/${cleanPath}`;
  };

  const value = {
    lang: currentLang,
    t,
    switchLanguage,
    getLocalizedPath,
    supportedLocales
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
